/* global Tena */

(function($) {
    Tena.Alignment = {
        groups: [],
        init: function() {
            var $rows = $('.body .container > .row'),
                $row,
                $item;
            $rows.each(function() {
                $row = $(this);
                if ($row.find('.align-height')) {
                    var $items = $row.find('.align-height').filter(function() {
                        $item = $(this);

                        return !$item.is('.fixed-height');
                    });
                    if ($items.size() > 1 || Tena.Alignment.isSingleProductBox($items)) {
                        Tena.Alignment.groups.push($items);
                    }
                }
            });
            Tena.Alignment.resize();
            Tena.Alignment.bindEvents();
        },
        bindEvents: function() {
            var winWidth = $(window).width(),
                winHeight = $(window).height();
            $('.tab').click(Tena.Alignment.resize);
            $(window).load(Tena.Alignment.resize);
            $(window).resize(function() {
                var newWidth = $(window).height(),
                    newHeight = $(window).width();
                if (winWidth !== newWidth || winHeight !== newHeight) {
                    Tena.Alignment.resize();
                    winWidth = newWidth;
                    winHeight = newHeight;
                }
            });

            // Hook up lazyload event to resize boxes after images are loaded.
            $(document).on('lazyloaded', function(e) {
                if ($(e.target).closest('.align-height').length > 0) {
                    Tena.Alignment.resize();
                }
            });
        },
        resetPushboxContentAlignment: function($container) {
            $container = $container || $('body');
            $container.find('.pushbox .js-align-bottom').css({
                marginTop: 0
            });
        },
        alignPushboxContentToBottom: function($container) {
            $container = $container || $('body');
            var $pushboxes = $container
                .find('.pushbox .js-align-bottom')
                .closest('.pushbox-content');
            $pushboxes.each(function() {
                var $pushbox = $(this),
                    totalHeight = $pushbox.outerHeight(),
                    contentHeight = 0,
                    difference = 0;
                // Calculate content height
                $pushbox
                    .children()
                    .filter(function() {
                        return $(this).css('position') !== 'absolute';
                    })
                    .each(function() {
                        contentHeight += $(this).outerHeight(true);
                    });
                // Calculate difference
                difference = totalHeight - contentHeight;
                difference = Math.max(0, difference);
                // Fix difference using margin-top
                $pushbox.find('.js-align-bottom').css({
                    marginTop: difference
                });
            });
        },
        resize: function() {
            Tena.Alignment.resetPushboxContentAlignment();
            $.each(Tena.Alignment.groups, function(index, $group) {
                $group.height('auto');
                Tena.Alignment.alignAdjacentItems($group);
            });
            Tena.Alignment.alignPushboxContentToBottom();
            Tena.Alignment.alignTitleOffsets();
        },
        equalizeHeight: function($items) {
            var maxHeight = 0;
            $items.each(function() {
                var $item = $(this),
                    $dynamic = $item.find('.dynamic-height'),
                    height;
                if ($dynamic) {
                    var dynamicHeight = $dynamic.attr('data-dynamic-height');
                    $dynamic.outerHeight(dynamicHeight);
                    height = $item.outerHeight(true);
                    $dynamic.css({ height: '' });
                } else {
                    height = $item.outerHeight(true);
                }
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            // If the boxes are of uneven height, the background image in
            // 'type-image-full' might have problems filling the whole pushbox
            if (maxHeight % 2 !== 0) {
                maxHeight--;
            }
            $items.outerHeight(maxHeight);
        },
        alignAdjacentItems: function($items) {
            var $item,
                $adjacent = $().add(),
                offset = 0;
            $items.each(function() {
                $item = $(this);
                if (offset !== 0 && $item.offset().top !== offset) {
                    if ($adjacent.size() > 1) {
                        Tena.Alignment.equalizeHeight($adjacent);
                    }
                    $adjacent = $().add();
                }
                if ($item.offset().top === offset || $adjacent.size() === 0) {
                    $adjacent = $adjacent.add($item);
                }
                offset = $item.offset().top;
            });

            if ($adjacent.size() > 1 || Tena.Alignment.isSingleProductBox($adjacent)) {
                Tena.Alignment.equalizeHeight($adjacent);
            }
        },
        alignTitleOffsets: function() {
            var $sectionTitleOffsets = $('.align-title-offset');
            $sectionTitleOffsets.each(function() {
                var elemToAlign = $(this),
                    $sectionTitle = $(this)
                        .closest('.row')
                        .find('.component-title, .section-title')
                        .first();
                elemToAlign.css('padding-top', $sectionTitle.innerHeight());
            });
        },
        isSingleProductBox: function($items) {
            // We want to apply height logic to single product boxes since they are dependant on it.
            return (
                $items.size() === 1 && $items.first().hasClass('component-product-box')
            );
        }
    };
})(jQuery);
